var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pay-count-container body-container" },
    [
      _c(
        "div",
        { staticClass: "body-header" },
        [
          _c("el-page-header", {
            attrs: { content: _vm.title },
            on: { back: _vm.goBack },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "pay-main" }, [
        _c("h2", [_vm._v(_vm._s(_vm.title))]),
        _vm.type == 1
          ? _c(
              "ul",
              { staticClass: "product-list" },
              _vm._l(_vm.productList, function (item, index) {
                return _c(
                  "li",
                  {
                    key: item.id,
                    class: { active: _vm.selectProductId == item.id },
                    on: {
                      click: function ($event) {
                        return _vm.selectProduct(item.id, index)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "vip-title" }, [
                      _vm._v(_vm._s(item.vip_level) + "级VIP"),
                    ]),
                    _c("div", { staticClass: "vip-day" }, [
                      _vm._v("有效期："),
                      _c("strong", [_vm._v(_vm._s(item.vip_day))]),
                      _vm._v("天"),
                    ]),
                    _c("div", { staticClass: "vip-times" }, [
                      _vm._v("次数："),
                      _c("strong", [_vm._v(_vm._s(item.times))]),
                      _vm._v("次"),
                    ]),
                    _c("div", { staticClass: "price-text" }, [
                      _vm._v(
                        " ¥" + _vm._s(_vm.fomatterPrice(item.price)) + " "
                      ),
                    ]),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm.type == 2
          ? _c(
              "ul",
              { staticClass: "product-list" },
              _vm._l(_vm.productList, function (item, index) {
                return _c(
                  "li",
                  {
                    key: item.id,
                    class: { active: _vm.selectProductId == item.id },
                    on: {
                      click: function ($event) {
                        return _vm.selectProduct(item.id, index)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "count-text" }, [
                      _c("strong", [_vm._v(_vm._s(item.times))]),
                      _vm._v("次 "),
                    ]),
                    _c("div", { staticClass: "price-text" }, [
                      _vm._v(
                        " ¥" + _vm._s(_vm.fomatterPrice(item.price)) + " "
                      ),
                    ]),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _c("h3", { staticClass: "pay-type-title" }, [_vm._v("支付方式")]),
        _vm._m(0),
        _c(
          "div",
          { staticClass: "pay-btn" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.pay } },
              [_vm._v("立即购买")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "微信扫码支付",
            visible: _vm.dialogWechat,
            width: "240px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogWechat = $event
            },
            close: _vm.wechatPayClose,
          },
        },
        [_c("div", { ref: "wechat-pay-code", staticClass: "qrcode" })]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "pay-type" }, [
      _c("li", { staticClass: "active" }, [
        _c("img", {
          attrs: { src: require("@/assets/wechat_pay.svg"), alt: "" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }